/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AssociationPublicProfileService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * @returns any[]
   * @throws ApiError
   */
  public findPublic(): CancelablePromise<any[]> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/v1/public-profile/{userId}/{associationUserId}',
    });
  }
}
